const APP_STORE_URL = 'https://apps.apple.com/app/id6762038043';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.mythirdplace.android';

function isAndroid(): boolean {
  return typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);
}

export function getAppStoreUrl(): string {
  return isAndroid() ? PLAY_STORE_URL : APP_STORE_URL;
}

export function getAppStoreLabel(): string {
  return isAndroid() ? 'Get it on Google Play' : 'Download on the App Store';
}
